import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src", "width", "height"]

import { computed, nextTick, ref, watch } from 'vue'

import { assertNotNull } from '@/helpers/typing'
import { getImage, QuestionnaireView } from '@/models/onboarding'
import { OptionsPage, QuestionnaireFormOption } from '@/models/onboarding.types'

import Layout from '../Layout.vue'
import OptionRadio from '../OptionRadio.vue'
import OptionText from '../OptionText.vue'
import OptionCheckbox from '../OptionCheckbox.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Options',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as OptionsPage
})

const selectedOptions = ref<string[]>([])

watch(selectedOptions, (newValue) => {
  if (page.value.multipleOptions) {
    props.view.setCurrentChoice(newValue)
  } else {
    // `selectedOptions` is an array to make it easier
    // to handle multiple-option pages, but if this
    // is not a multi-option page, then `selectedOptions`
    // should only have one item.
    props.view.setCurrentChoice(newValue[0])
  }
})

const options = computed(() => {
  // Remove the `skip` option. We handle it differently than the other options.
  return page.value.options.filter((option) => option.type !== 'skip')
})

const skipOption = computed(() => {
  return page.value.options.find(
    (option) => typeof option !== 'string' && option.type === 'skip',
  ) as QuestionnaireFormOption | undefined
})

const image = computed(() => {
  if (!page.value.image) {
    return
  }

  return getImage(page.value.image.src)
})

/**
 * Set `selectedOptions` to the value of the `skipOption`,
 * and navigate to the next page.
 */
async function skip(): Promise<void> {
  selectedOptions.value = [assertNotNull(skipOption.value?.label)]
  // Wait for `watch`.
  await nextTick()

  await props.view.nextPage()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    id: page.value.id,
    class: "onboarding-options",
    title: page.value.title,
    subtitle: page.value.subtitle,
    scrollDefaultSlot: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["onboarding-options__options", {
        'onboarding-options__options--wrap': page.value.wrapInputs,
      }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (page.value.multipleOptions)
              ? (_openBlock(), _createBlock(OptionCheckbox, {
                  key: `a-${option.label}`,
                  modelValue: selectedOptions.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOptions).value = $event)),
                  class: _normalizeClass(["onboarding-options__option", { 'onboarding-options__option--center': page.value.centerText }]),
                  option: option,
                  maxOptions: page.value.maxOptions
                }, null, 8, ["modelValue", "class", "option", "maxOptions"]))
              : (option.type === 'text-input')
                ? (_openBlock(), _createBlock(OptionText, {
                    key: `b-${option.label}`,
                    modelValue: selectedOptions.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOptions).value = $event)),
                    class: _normalizeClass(["onboarding-options__option", { 'onboarding-options__option--center': page.value.centerText }]),
                    option: option
                  }, null, 8, ["modelValue", "class", "option"]))
                : (_openBlock(), _createBlock(OptionRadio, {
                    key: `c-${option.label}`,
                    modelValue: selectedOptions.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedOptions).value = $event)),
                    class: _normalizeClass(["onboarding-options__option", { 'onboarding-options__option--center': page.value.centerText }]),
                    option: option
                  }, null, 8, ["modelValue", "class", "option"]))
          ], 64))
        }), 256))
      ], 2),
      (skipOption.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "onboarding-options__option-skip",
            onClick: skip
          }, _toDisplayString(skipOption.value.label), 1))
        : _createCommentVNode("", true),
      (page.value.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "onboarding-options__image",
            src: image.value,
            width: page.value.image.width,
            height: page.value.image.height,
            alt: ""
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["id", "title", "subtitle"]))
}
}

})